var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"variation":"clear","size":"sm"},on:{"click":_vm.removeItem}},[_c('app-icon',{staticClass:"cf-u-color-danger",attrs:{"icon":"delete-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }